/** Desktop page titles (longer than sidebar labels) + breadcrumb. */
export const pageChromeEn = {
  breadcrumbNav: 'Breadcrumb',
  breadcrumbHome: 'Home',
  pageTitleDashboard: 'Control panel',
  pageTitleHouses: 'House management',
  pageTitleUsers: 'User management',
  pageTitleTickets: 'Support tickets',
  pageTitleKnowledge: 'Knowledge library',
  pageTitleAudit: 'Audit log',
  pageTitleIntegrity: 'Integrity monitor',
  pageTitleConfig: 'Settings',
  pageTitleRates: 'Exchange rates',
  pageTitlePlays: 'Play ledger',
  pageTitleResults: 'Draw results',
  pageTitleRoute: 'Collection route',
  pageTitleNewPlay: 'New play',
  pageTitleHandoff: 'Handoff',
  pageTitleHistory: 'Collection history',
  pageTitleAnalytics: 'Support analytics',
} as const;

export const pageChromeEs = {
  breadcrumbNav: 'Ruta de navegación',
  breadcrumbHome: 'Inicio',
  pageTitleDashboard: 'Panel de Controles',
  pageTitleHouses: 'Gestión de casas',
  pageTitleUsers: 'Gestión de usuarios',
  pageTitleTickets: 'Tickets de soporte',
  pageTitleKnowledge: 'Biblioteca de conocimiento',
  pageTitleAudit: 'Registro de auditoría',
  pageTitleIntegrity: 'Monitor de integridad',
  pageTitleConfig: 'Configuración',
  pageTitleRates: 'Tasas de cambio',
  pageTitlePlays: 'Libro de jugadas',
  pageTitleResults: 'Resultados del sorteo',
  pageTitleRoute: 'Ruta de cobro',
  pageTitleNewPlay: 'Nueva jugada',
  pageTitleHandoff: 'Entrega',
  pageTitleHistory: 'Historial de cobros',
  pageTitleAnalytics: 'Analítica de soporte',
} as const;
